module.exports = __webpack_public_path__ + "img/openHarmony.7906764.png";